<template lang="pug">
  b-modal#select_datetime.my-modal(centered, ok-only, size="xl", title='作業日時選択', @ok="setDateTime", @show="modalOpen", :ok-disabled="!isMigrationTimeOpen", ok-title="決定")
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      .select_datetime
        h5.font-weight-bold 日付選択
        h6.font-weight-bold.text-center
          .form-inline.justify-content-center
            b-button(variant="link" :disabled="isLoading || !isAvailablePrevCalendar" size="sm" @click="movePrevMonth()") ＜
            .mx-2 {{showTitle}}
            b-button(variant="link" :disabled="isLoading || !isAvailableNextCalendar"  size="sm" @click="moveNextMonth()") ＞
        b-table-simple.rounded.text-center(small, responsive="responsive", bordered)
          b-tr
            b-th 日
            b-th 月
            b-th 火
            b-th 水
            b-th 木
            b-th 金
            b-th 土
          b-tr(v-for="(week, key) of weeks")
            b-td(v-for="(day, key) of week.days", :class="day.class", @click="day.class === 'past-date' ? null : selectDate(day)")
              template(v-if="day.dateObject")
                b-form-text {{day.dateObject.getDate()}}
                b-form-text(v-if="day.day_workable_number > 0 && day.class !== 'past-date'") 〇
                b-form-text(v-else) ×
        b-collapse(v-model="isSelectTimeOpen")
          h3.font-weight-bold.text-center.mt-4 ⇓
          h5.font-weight-bold.mt-4 時間選択
          b-table-simple.rounded.text-center(small, responsive="responsive", bordered)
            b-tr
              b-th 10:00 - 11:00
              b-th 11:00 - 12:00
              b-th 13:00 - 14:00
              b-th 14:00 - 15:00
              b-th 15:00 - 16:00
              b-th 16:00 - 17:00
            b-tr
              b-td(v-for="(time, hour) of times", :class="time.class", @click="selectTime(time)")
                b-form-text(v-if="time.capacity > 0") 〇
                b-form-text(v-else) ×
        b-collapse(v-model="isMigrationTimeOpen")
          .form-inline
            h6.font-weight-bold.mt-4 選択日時：
            b-form-text.choice-date-size.mt-3 {{showMigrationTime}}
</template>

<script>
/* eslint-disable */
import Api from '@/repositories/api'
import Loading from '@/components/Loading';
const M201WorkableScheduleRepository = Api.get('M201WorkableSchedule')

export default {
  name: "SelectDatetime",
  components: {
    Loading
  },
  props: {
    value: { type: Object, required: true},
  },
  data() {
    return {
      isLoading:           false, // 読み込み中フラグ
      isSelectTimeOpen:    false, // 時刻選択欄表示フラグ
      isMigrationTimeOpen: false, // 選択日時表示フラグ

      weeks:          [],   // カレンダーの日付
      objSelectDate:  null, // 選択している日付
      objConfirmDate: null, // 時刻選択時の日付（時刻の選択済み表示のために使用）
      objSelectTime:  null, // 選択している時刻オブジェクト（から）

      objShowMonth:        new Date(), // 今表示している年月
      objWorkableSchedule: {},         // 各日付の作業可能時刻
      minDate:             new Date(), // 選択できる最小日付
      objSelectableDayMax: null,       // 表示上限月の日付

      // 作業可能時刻
      times: {
        10: { hour: 10, capacity: 0, class: '' },
        11: { hour: 11, capacity: 0, class: '' },
        13: { hour: 13, capacity: 0, class: '' },
        14: { hour: 14, capacity: 0, class: '' },
        15: { hour: 15, capacity: 0, class: '' },
        16: { hour: 16, capacity: 0, class: '' },
      },
    }
  },
  computed: {
    showTitle() {
      // カレンダーの表示月（「yyyy年MM月」）
      return this.objShowMonth.getFullYear() + '年' + (this.objShowMonth.getMonth() + 1) + '月';
    },
    showMigrationTime() {
      // 日付初期化
      let sDay = '';

      // 日付が選択済み
      if (this.objSelectDate !== null) {
        // 表示用の文字列作成
        sDay = this.objSelectDate.dateObject.getFullYear() + "年"
          + ("0" + (this.objSelectDate.dateObject.getMonth() + 1)).slice(-2) + "月"
          + ("0" + this.objSelectDate.dateObject.getDate()).slice(-2) + "日"
      }

      // 時刻初期化
      let sTime = '';

      // 時間が選択済み
      if (this.objSelectTime !== null) {
        // 表示用の文字列作成
        sTime = this.objSelectTime.hour + ':00 - ' + (this.objSelectTime.hour + 1) + ':00';
      }

      // 日付・時刻を連結（「yyyy年MM月dd日 HH:mm - HH:mm」形式）
      return sDay + ' ' + sTime;
    },
    /**
     * 前月のカレンダーが表示可能であるか判定する
     */
     isAvailablePrevCalendar() {
      // 現在の表示月
      let objLastMonth = new Date(this.objShowMonth.getTime());
      // 前月1日に移動
      objLastMonth.setUTCMonth(objLastMonth.getMonth() -1, 1);
      // 現在のシステム日付を取得
      let objCurrentDate = new Date()
      // 当月1日に移動
      objCurrentDate.setUTCDate(1);

      // 時間差を算出する
      let iDiffMonths = (objCurrentDate.getFullYear() - objLastMonth.getFullYear()) * 12 + (objCurrentDate.getMonth() - objLastMonth.getMonth())

      // 前月以降のカレンダーである場合
      if (iDiffMonths > 0) {
        return false
      }

      return true
    },
    /**
     * 翌月のカレンダーが有効であるか判定する
     */
    isAvailableNextCalendar() {
      // 現在の表示月
      let objNextMonth = new Date(this.objShowMonth.getTime());
      // 翌月1日に移動
      objNextMonth.setUTCMonth(objNextMonth.getMonth() + 1, 1);
      // 現在のシステム日付を取得
      let objCurrentDate = new Date()
      // 当月1日に移動
      objCurrentDate.setUTCDate(1);

      // 時間差を算出する
      let iDiffMonths = (objNextMonth.getFullYear() - objCurrentDate.getFullYear()) * 12 + (objNextMonth.getMonth() - objCurrentDate.getMonth())

      // 2カ月後以降のカレンダーである場合
      if (iDiffMonths > 1) {
        return false
      }

      return true
    },
  },
  created() {
    //------------------------------
    // 選択できる最小日付を設定
    //------------------------------
    // 初期化
    let workDate      = new Date(); // 作業日付
    let iCountWorkDay = 0;          // 営業日

    // 最大2ヶ月先
    for (let i = 0; i++ < 63; i++) {
      // 翌日へ
      workDate.setDate(workDate.getDate() + 1);

      // 受け入れ可能営業日になった
      if (iCountWorkDay === this.returnDisabledWorkableDays() - 1) {
        // 最小日付にセット
        this.minDate = workDate;

        // 処理終了
        break;
      }

      // 土日
      if (workDate.getDay() === 0 || workDate.getDay() === 6) {
        // 営業日のカウントをしない
        continue;
      }

      // 祝日
      if (this.getHolidays().indexOf(workDate.getFullYear() + "-"
        + ("0" + (workDate.getMonth() + 1)).slice(-2) + "-"
        + ("0" + workDate.getDate()).slice(-2)) !== -1) {
        // 営業日のカウントをしない
        continue;
      }

      // 営業日のカウント
      iCountWorkDay++;
    }
  },
  methods: {
    /**
     * モーダル表示処理
     */
    modalOpen() {
      // 読み込み中フラグを立てる
      this.isLoading = true;

      // 初期化
      this.isSelectTimeOpen    = false; // 時刻選択欄を非表示
      this.isMigrationTimeOpen = false; // 選択日時を非表示
      this.objSelectDate       = null;  // 日付の選択

      // 選択済みの日付があれば初期値として設定
      if (this.value && this.value.date) {
        // 初期値
        this.isSelectTimeOpen    = true; // 時刻選択欄を表示
        this.isMigrationTimeOpen = true; // 選択日時を表示

        // 選択日付
        this.objSelectDate = {
          class: 'selected-date',
          dateObject: new Date(this.value.date)
        }

        // 時刻の初期値表示用の日付も設定
        this.objConfirmDate = this.objSelectDate

        // 選択時刻
        this.objSelectTime = {
          hour: Number(this.value.start_time),
          capacity: 1,
          class: 'selected-date'
        };
      }

      // 作業可能日時を取得
      M201WorkableScheduleRepository.get()
      .then((response) => {
        // 作業可能日時を保存
        this.objWorkableSchedule = response.data.workable_schedule;

        // カレンダー作成
        this.createCalendar(new Date());
      })
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, '作業可能日時取得処理', 'FirstOrder')
      })
      .finally(() => {
        // 読み込みフラグをおろす
        this.isLoading = false;
      });
    },
    /**
     * カレンダー作成
     *
     * @param {object} objMakeDate 対象月の日付（Dateオブジェクト）
     */
    createCalendar(objMakeDate) {
      // 対象月のDateオブジェクト作成
      const objTargetDate = new Date(objMakeDate.getTime());

      // 対象月の1日にセット
      objTargetDate.setUTCDate(1);

      // タイトル用の日付
      this.objShowMonth = new Date(objMakeDate.getTime());

      // 現在作成中の週
      let iNowWeek = 0;

      // 第一週のデータ生成
      this.weeks = [
        {
          week: iNowWeek,
          days: [],
        }
      ]

      // 1日が日曜でない場合、前月の日付を空白で埋める
      if (objTargetDate.getDay() !== 0) {
        for (let i = 0; i < objTargetDate.getDay(); i++) {
          // 選択不可で埋める
          this.weeks[iNowWeek].days.unshift({
            dateObject: null,
            class: 'past-date'
          })
        }
      }

      // 日付生成
      for (let i = 1; i < 32; i++) {
        // 対象の日付をセット
        objTargetDate.setUTCDate(i);

        // 翌月になったら処理終了
        if (objTargetDate.getMonth() !== objMakeDate.getMonth()) {
          break;
        }

        // 一週間分作り終えた
        if (objTargetDate.getDay() === 0 && i !== 1) {
          // 翌週
          iNowWeek++;

          // 翌週分のデータ作成
          this.weeks[iNowWeek] = {
            week: iNowWeek,
            days: []
          };
        }

        // カレンダーに追加する日付の作業用オブジェクト
        let objWorkDate = {
          dateObject: new Date(objTargetDate.getTime()),
          class: ''
        }

        // ステータスの設定
        // 最小日付以前
        if (objTargetDate.getTime() < this.minDate.getTime()) {
          // 選択不可のクラス付与
          objWorkDate.class = 'past-date';
        }
        // 最小日付以降
        else {
          // 土日
          if (objTargetDate.getDay() === 0 || objTargetDate.getDay() === 6) {
            // 選択不可のクラス付与
            objWorkDate.class = 'past-date';
          }
          // 祝日
          else if (this.getHolidays().indexOf(objTargetDate.getFullYear() + "-"
            + ("0" + (objTargetDate.getMonth() + 1)).slice(-2) + "-"
            + ("0" + objTargetDate.getDate()).slice(-2)) !== -1) {
            // 選択不可のクラス付与
            objWorkDate.class = 'past-date';
          }
          // 平日
          else {
            // 作業可能数を確認する
            for (const [sDate, objSchedule] of Object.entries(this.objWorkableSchedule)) {
              // 日付を取得する
              const objWorkableDate = new Date(sDate);

              // 作業可能数と日付が一致
              if (objWorkDate.dateObject.getFullYear() === objWorkableDate.getFullYear()
                && objWorkDate.dateObject.getMonth() === objWorkableDate.getMonth()
                && objWorkDate.dateObject.getDate() === objWorkableDate.getDate()) {
                // 一日の合計作業可能数を設定する
                objWorkDate.day_workable_number = objSchedule.day_workable_number;

                // 時間ごとの作業可能数を設定する
                objWorkDate.time_workable_number = {
                  10: objSchedule['10'].workable_number,
                  11: objSchedule['11'].workable_number,
                  13: objSchedule['13'].workable_number,
                  14: objSchedule['14'].workable_number,
                  15: objSchedule['15'].workable_number,
                  16: objSchedule['16'].workable_number,
                };

                // 作業可能
                if (objWorkDate.day_workable_number > 0) {
                  // 選択可のクラス付与
                  objWorkDate.class = 'ok-date'
                }
                // 作業不可
                else {
                  // 選択不可のクラス付与
                  objWorkDate.class = 'ng-date'
                }

                break;
              }
            }
          }

          // 対象の日付が選択済み
          if (this.objSelectDate !== null
            && this.objSelectDate.dateObject.getFullYear() === objTargetDate.getFullYear()
            && this.objSelectDate.dateObject.getMonth() === objTargetDate.getMonth()
            && this.objSelectDate.dateObject.getDate() === objTargetDate.getDate()) {
            // 選択済みのクラス付与
            objWorkDate.class = 'selected-date';

            // 選択済み保存用の参照先も作成した日付にする
            this.objSelectDate = objWorkDate

            // 時刻の表示処理（日付が保存済みであれば必ず時間もある）
            this.setWorkableTimes()
          }
        }

        // カレンダーに日付を追加
        this.weeks[iNowWeek].days.push(objWorkDate);
      }
    },
    /**
     * カレンダーを翌月にする
     */
    moveNextMonth() {
      // 現在の表示月
      let objNextMonth = new Date(this.objShowMonth.getTime());

      // 翌月1日に移動
      objNextMonth.setUTCMonth(objNextMonth.getMonth() + 1, 1);

      // 翌月のカレンダーが有効である場合
      if (this.isAvailableNextCalendar === true) {
        // 翌月のカレンダー生成
        this.createCalendar(objNextMonth);
      }
    },
    /**
     * カレンダーを前月にする
     */
    movePrevMonth() {
      // 現在の表示月
      let objPrevMonth = new Date(this.objShowMonth.getTime())

      // 前月末日に移動
      objPrevMonth.setUTCMonth(objPrevMonth.getMonth(), 0)

      // 前月のカレンダーが有効である場合
      if (this.isAvailablePrevCalendar === true) {
        // 前月のカレンダー生成
        this.createCalendar(objPrevMonth)
      }
    },
    /**
     * 日付を選択する
     *
     * @param {object} selectDate 選択日付
     */
    selectDate(selectDate) {
      // 選択可で未選択か
      if (selectDate.day_workable_number > 0 && selectDate.class !== 'selected-date' && selectDate.class !== 'past-date') {
        // 選択日時の表示を隠す
        this.isMigrationTimeOpen = false;

        // 元々入力した日付がある場合は選択状態を解除する
        if (this.objSelectDate !== null) {
          // 選択可のクラス付与
          this.objSelectDate.class = 'ok-date'
        }

        // 選択された日付に選択済みのクラス付与
        selectDate.class = 'selected-date';

        // 選択している日付を上書き
        this.objSelectDate = selectDate;

        // 時刻の選択を空にする
        this.objSelectTime = null;

        // 時刻選択欄を表示
        this.isSelectTimeOpen = true;

        // 時刻の選択肢を更新
        this.setWorkableTimes();
      }
    },
    /**
     * 時刻の選択肢を更新
     */
    setWorkableTimes() {
      // 作業可能時刻を反映
      for (const [hour, time] of Object.entries(this.times)) {
        // 作業可能時刻を設定
        time.capacity = this.objSelectDate.time_workable_number[hour];

        // 該当日付の時刻を選択済み
        if (this.objConfirmDate !== null
          && this.objSelectDate.dateObject.getFullYear() === this.objConfirmDate.dateObject.getFullYear()
          && this.objSelectDate.dateObject.getMonth() === this.objConfirmDate.dateObject.getMonth()
          && this.objSelectDate.dateObject.getDate() === this.objConfirmDate.dateObject.getDate()
          && this.objSelectTime !== null
          && (Number)(hour) === this.objSelectTime.hour) {
          // 選択済みのクラス付与
          time.class = 'selected-date';

          // 選択している時刻オブジェクトを設定
          this.objSelectTime = time;

          // 選択した作業日時を表示
          this.isMigrationTimeOpen = true;
        }
        // 選択可
        else if (time.capacity > 0) {
          // 選択可のクラス付与
          time.class = 'ok-date';
        }
        // 選択不可
        else {
          // なにも設定しない（選択不可）
          time.class = '';
        }
      }
    },
    /**
     * 時刻を選択する
     *
     * @param {object} selectTime 選択した時刻のオブジェクト
     */
    selectTime(selectTime) {
      // 入力した時刻が選択可
      if (selectTime.capacity > 0) {
        // 入力した日付を選択状態にする
        selectTime.class = 'selected-date'

        // 選択していた時刻がある
        if (this.objSelectTime !== null) {
          // 元々選択していた時刻に空き容量がある
          if (this.objSelectTime.capacity > 0) {
            // 選択可のクラス付与
            this.objSelectTime.class = 'ok-date';
          }
          // 空き容量がない
          else {
            // 何も設定しない（選択不可）
            this.objSelectTime.class = '';
          }
        }

        // 時刻のデータを更新
        for (const [hour, time] of Object.entries(this.times)) {
          // 選択した時刻
          if ((Number)(hour) === selectTime.hour) {
            // 選択済みのクラス付与
            time.class = 'selected-date';
          }
        }

        // 選択時刻を上書き
        this.objSelectTime = selectTime;

        // 時刻の初期値表示用の日付を設定
        this.objConfirmDate = this.objSelectDate;

        // 選択した作業日時を表示
        this.isMigrationTimeOpen = true;
      }
    },
    /**
     * 選択した日時を呼び出し元の変数に返す
     */
    setDateTime() {
      // 日付・時刻が選択されてる場合のみ親に返す
      if (this.objSelectDate !== null && this.objSelectTime !== null) {
        // 各値を親に返す
        this.value.date       = this.objSelectDate.dateObject.toISOString().split('T')[0]; // 選択した日付
        this.value.start_time = this.objSelectTime.hour;     // 選択した時刻（から）
        this.value.end_time   = this.objSelectTime.hour + 1; // 選択した時刻（まで）

        // 親のdoneを発火
        this.$emit('done');
      }
    }
  }
}
</script>

<style scoped>
.ok-date {
  background-color: orange;
}
.selected-date {
  background-color: cyan;
}
.past-date {
  background-color: lightgray;
}
.ng-date {
  background-color: white;
}
.ok-date:hover,
.selected-date:hover {
  cursor : pointer;
}
.choice-date-size {
  font-size: 16px
}
</style>